import React from 'react';
import { useTranslation } from 'react-i18next';
import { Applicant } from '../core/types';

interface Props {
  applicant: Applicant;
  caseId: string;
}

const ApplicantPanel: React.FC<Props> = ({ applicant, caseId }) => {
  const { t } = useTranslation();
  const [imgError, setImgError] = React.useState(false);
  return (
    <div className="applicant-panel">
      <h2>{t('applicant.title')}</h2>
      {!imgError ? (
        <img
          className="portrait-photo"
          src={`/images/portraits/${caseId}.jpg`}
          alt={applicant.name}
          onError={() => setImgError(true)}
        />
      ) : (
        <div className="portrait-placeholder">{applicant.name.charAt(0)}</div>
      )}
      <div className="applicant-info">
        <div><strong>{t('applicant.name')}:</strong> {applicant.name}</div>
        <div><strong>{t('applicant.age')}:</strong> {applicant.age}</div>
        <div><strong>{t('applicant.country')}:</strong> {applicant.country}</div>
        <div><strong>{t('applicant.occupation')}:</strong> {applicant.occupation}</div>
      </div>
    </div>
  );
};

export default ApplicantPanel;
